var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-big"},_vm._l((_vm.iconListbig),function(item){return _c('img',{attrs:{"src":item.url,"alt":""},on:{"click":function($event){return _vm.openLink(item.link)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }